// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (quoteId: string) => axios.get(`/quotes/${quoteId}/saves`);

export type LoadTempSavePayload = {
  quoteId: string,
  saveId: string,
};

export const loadTempSave = ({ quoteId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/quotes/${quoteId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/quotes/saves.js